module.exports = __webpack_public_path__ + "2023630/img/avatar.f57ebce8.png";